<template>
    <div class="row">
        <div v-if="isLoading" class="col-12">
            <font-awesome-icon icon="spinner" spin/>
        </div>
        <div v-else style="width:100%;">
            <div class="row">
                <div class="col-12 mb-3" v-if="hasPermission('locations.services.edit')">
                    <div class="d-none d-sm-block float-right "> <!-- desktop versie -->
                        <button v-if="hasEditableFields" type="submit" class="btn btn-success" @click="saveProperties" :disabled="isSaving">{{ $t('omt.gui.general.action.save') }}</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <b-card>
                        <b-card-title class="text-uppercase">
                          {{ $t('omt.gui.location-management.service-settings.title') }}
                        </b-card-title>

                        <div class="table-responsive table-hover">
                            <table class="table table-hover">
                                <col style="width: 25%">
                                <col style="width:auto">

                                <tr v-for="(dispatchType, index) in dispatchTypes" :key="index">
                                    <td class="align-text-top pt-3"><strong>{{ dispatchType.display_name }}</strong></td>
                                    <td class="align-middle">
                                        <p v-if="!dispatchType.is_active">{{ $t('omt.gui.general.label.off') }}</p>
                                        <p v-else-if="dispatchType.readonly">
                                            <span v-if="dispatchType.is_active_for_location !== '0'">{{ $t('omt.gui.general.label.on') }}</span>
                                            <span v-else>{{ $t('omt.gui.general.label.off') }}</span>
                                        </p>
                                        <span v-else>
                                    <input type="radio"
                                           value="0"
                                           :name="dispatchType.identifier"
                                           :id="`${dispatchType.identifier}False`"
                                           v-model="dispatchType.is_active_for_location"
                                    />  <label :for="`${dispatchType.identifier}False`">{{ $t('omt.gui.general.label.off') }}</label><br/>
                                    <input type="radio"
                                           value="1"
                                           :name="dispatchType.identifier"
                                           :id="`${dispatchType.identifier}True`"
                                           v-model="dispatchType.is_active_for_location"
                                    />  <label :for="`${dispatchType.identifier}True`">{{ $t('omt.gui.general.label.on') }}</label>
                                </span>

                                        <b-card class="mb-1 bg-light shadow-none"
                                                v-if="dispatchType.is_active && dispatchType.is_active_for_location !== '0'"
                                                v-for="carrier in dispatchType.carriers"
                                                :key="carrier.id"
                                                no-body
                                        >

                                            <b-card-body class="pb-1">
                                                <b-card-title>{{ carrier.display_name }}</b-card-title>
                                                <div v-for="carrierMethod in carrier.carrier_methods" :key="carrierMethod.id">
                                                    <table style="width:100%;" class="table-sm">
                                                        <col style="width: 30%">
                                                        <col style="width:auto">
                                                        <tr>
                                                            <td><i>{{ carrierMethod.display_name }}</i></td>
                                                            <td>
                                                                <p v-if="!carrierMethod.is_active" class="pt-2">{{ $t('omt.gui.general.label.off') }}</p>
                                                                <p v-else-if="carrierMethod.readonly || dispatchType.readonly">
                                                                    <span v-if="carrierMethod.is_active_for_location !== '0'">{{ $t('omt.gui.general.label.on') }}</span>
                                                                    <span v-else>{{ $t('omt.gui.general.label.off') }}</span>
                                                                </p>
                                                                <span v-else>
                                                                    <b-form-checkbox
                                                                        v-model="carrierMethod.is_active_for_location"
                                                                        switch
                                                                        :id="`${dispatchType.identifier}${carrierMethod.identifier}`"
                                                                        :name="`${dispatchType.identifier}${carrierMethod.identifier}`"
                                                                        :unchecked-value="'0'"
                                                                        :value="'1'" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <table style="width:100%;">
                                                        <col style="width: 5%">
                                                        <col style="width: 25%">
                                                        <col style="width:auto">
                                                        <tr v-for="(property, propertyKey) in carrierMethod.properties" :key="`${carrierMethod.id}.${propertyKey}`"
                                                            v-show="carrierMethod.is_active && carrierMethod.is_active_for_location !== '0'"
                                                        >
                                                            <td></td>
                                                            <td>{{ property.display_name }}</td>
                                                            <td>
                                                                <textarea disabled="disabled" v-if="carrierMethod.readonly || dispatchType.readonly || property.readonly" :value="carrierMethod.properties[propertyKey].value" class="form-control"></textarea>
                                                                <textarea v-else v-model="carrierMethod.properties[propertyKey].value" class="form-control"></textarea>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </b-card-body>
                                        </b-card>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </b-card>
                </div>
            </div>

            <div class="col-12 my-3" v-if="hasPermission('locations.services.edit')">
                <div class="d-none d-sm-block float-right "> <!-- desktop versie -->
                    <button v-if="hasEditableFields" type="submit" class="btn btn-success" @click="saveProperties" :disabled="isSaving">{{ $t('omt.gui.general.action.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash"

export default {
    name: "LocationServices",

    props: {
        location: {required: true, type: Object},
    },


    data() {
        return {
            isLoading: true,
            isSaving: false,
            success: '',
            error: '',
            isDataChanged: false,
            dispatchTypes: [],
            originalDispatchTypes: '',
        }
    },

    computed: {
        hasEditableFields() {
            // Maak een lijst van dispatch types die zelf óf een onderliggende waarde ervan te wijzigen is
            return this.dispatchTypes
                .some(dispatchType => {
                    if (dispatchType.readonly) {
                        return false
                    }

                    return dispatchType?.carriers
                        .some(carrier => carrier.carrier_methods?.some(carrierMethod => {
                            if (carrierMethod.readonly || !carrierMethod.properties) {
                                return false
                            }

                            return Object.values(carrierMethod?.properties).some(property => !property.readonly)
                        }));
                })
        },
        hasChanges() {
            return JSON.stringify(this.dispatchTypes) !== this.originalDispatchTypes
        },
    },

    mounted() {
        this.initialize()
    },

    methods: {
        initialize() {
            this.$http.get(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/dispatch-types`)
                .then(dispatchTypes => {
                    this.dispatchTypes = dispatchTypes.data
                        .map(dispatchType => {
                            dispatchType.is_active_for_location = dispatchType.is_active_for_location ? '1' : '0'
                            dispatchType.carriers
                                .map(carrier => {
                                    carrier.carrier_methods.map(method => {
                                        method.is_active_for_location = method.is_active_for_location ? '1' : '0'
                                        return method
                                    })

                                    return carrier
                                })
                            return dispatchType
                        })

                    this.originalDispatchTypes = JSON.stringify(this.dispatchTypes)
                    this.isLoading = false
                })
                .catch(e => {
                    console.error(e)
                    this.error = 'Fout bij het ophalen van locatiegegevens'
                })

        },
        saveProperties() {
            this.isSaving = true

            // Save services
            let servicesPostData = []
            _.each(this.dispatchTypes, dispatchType => {
                if (dispatchType.readonly || !dispatchType.is_active) {
                    return
                }

                let dispatchTypeData = {
                    identifier: dispatchType.identifier,
                    location_property_key_prefix: dispatchType.location_property_key_prefix,
                    is_active_for_location: dispatchType.is_active_for_location !== '0',
                    carriers: [],
                }

                _.each(dispatchType.carriers, carrier => {
                    let carrierData = {
                        identifier: carrier.identifier,
                        carrier_methods: [],
                    }

                    _.each(carrier.carrier_methods, method => {
                        if (method.readonly || !method.is_active) {
                            return
                        }

                        carrierData.carrier_methods.push({
                            identifier: method.identifier,
                            location_property_key_prefix: method.location_property_key_prefix,
                            is_active_for_location: method.is_active_for_location !== '0',
                            properties: _.mapValues(method.properties, prop => prop.value),
                        })
                    })

                    dispatchTypeData.carriers.push(carrierData)
                })

                servicesPostData.push(dispatchTypeData)

            })

            this.$http.patch(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/dispatch-types`, servicesPostData)
                .then(dispatchTypes => {
                    this.originalDispatchTypes = JSON.stringify(this.dispatchTypes)
                    this.$alert('Service instellingen opgeslagen')
                })
                .catch(e => {
                    this.$alert('Fout bij het opslaan, probeer het opnieuw', 'danger', true)
                })
                .then(() => {
                    this.isSaving = false
                })
        },
    },
}
</script>
